import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import Clauses from '@Pages/ClauseTree';
import ClausesDetails from '@Pages/ClauseTree/pages/ClauseDetails';
import Scorecards from '@Pages/Scorecards';
import Labels from '@Pages/Labels';
import DocumentMarkup from '@Pages/Markup';
import Settings from '@Pages/Settings';
import Contracts from '@Pages/Contracts';
import LoadingContainer from '@Pages/Loading';
import PrivateRoute from './PrivateRoute';

const ContentRoute = () => {
    const location = useLocation();
    const clauseDetailsOverlay = location.state && location.state.clauseDetailsOverlay;

    return (
        <>
            <Switch location={clauseDetailsOverlay || location}>
                <PrivateRoute path="/scorecards" component={Scorecards} key="scorecards" />
                <PrivateRoute path="/contracts" component={Contracts} key="contracts" />
                <PrivateRoute path="/labels" component={Labels} key="labels" />
                <PrivateRoute path="/clauses" component={Clauses} key="clauses" />
                <PrivateRoute path="/markup" component={DocumentMarkup} key="markup" />
                <PrivateRoute path="/loading" component={LoadingContainer} key="loading" />
                <Route path="/settings" component={Settings} key="settings" />
                <Route path="/" component={Settings} key="/" />
            </Switch>
            {clauseDetailsOverlay && (
                <PrivateRoute
                    path="/clauses/:id"
                    component={ClausesDetails}
                    key="clauses-details"
                />
            )}
        </>
    );
};

export default ContentRoute;
